import Spinner from '../common/Spinner';

const PageLoader = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <Spinner />
  </div>
);

export default PageLoader;
